import React, { useState } from "react";
import { useAppSelector, useAppDispatch } from "../../app/hooks";

import Link from "@mui/material/Link";
import { Link as RLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";

import Dialog, { DialogProps } from "@mui/material/Dialog";
import { selectTicket } from "./ticketSlice";

interface QueryProps {
    id: string | null;
    parent_id: string | null;
    onChange: () => void;
}

export default function EditToolBar({ id, onChange, parent_id }: QueryProps) {
    const sx = {
        backgroundColor: "#eeeeee",
        display: "flex",
        height: 45,
        width: "100%",
        paddingLeft: 3,
        paddingRight: 8,
        alignItems: "center",
    };
    const sxleft = {
        flexGrow: 1,
        //backgroundColor: 'green',
    };
    const sxright = {
        flexGrow: 4,
        //backgroundColor: 'yellow',
    };

    const ticket = useAppSelector(selectTicket(id ? id : ""));
    const idLinkString = id ? "/" + id : "";
    const parentIdLinkString = ticket ? "/" + ticket.parent_id : "";
    return (
        <Box position="fixed" sx={sx}>
            <Box sx={sxleft}>
                <Typography>Tickets</Typography>
            </Box>
            <Box sx={sxright}>
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    size="small"
                    onClick={onChange}
                >
                    Save
                </Button>
                {" - "}
                <Link component={RLink} to={"/ticket/view" + idLinkString}>
                    <Button variant="outlined" size="small" onClick={onChange}>
                        Cancel
                    </Button>
                </Link>
                {" - "}
                <Link
                    component={RLink}
                    to={"/ticket/view" + parentIdLinkString}
                >
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        size="small"
                        onClick={onChange}
                    >
                        Up
                    </Button>
                </Link>
            </Box>
        </Box>
    );
}
